import React, { useContext } from "react";
import { PhotoManagerContext } from "./index";
const gssNewLoader = require("../../../assets/gss-loader.gif");

const NoFilteredEvents = () => {
  const context = useContext(PhotoManagerContext);

  return (
    <>
      {context?.isFilterEventsLoading ? (
        <div className="gss-loader">
          <img src={gssNewLoader} />
        </div>
      ) : (
        <div className="geo-display-center no-filtered-events-container">
          <div className="no-filtered-events-head">
            {`No ${context?.selectedEventFilter} events found`}
          </div>

          <div className="no-filtered-events-actions">
            <button
              type="button"
              className="geo-btn geo-btn--small geo-btn-primary-lt-green geo-btn--caps"
              onClick={() => context?.clearFilter()}
            >
              Clear Filters
            </button>
            <span className="or-text">Or</span>
            <a
              href={"/dashboard/events/new/our"}
              className="geo-btn geo-btn--small geo-btn--secondary geo-btn--caps"
            >
              Create Event
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default NoFilteredEvents;
